import produce from 'immer';

import {
  CONFIG_UNLINKED_VIOLATION_TYPES_FETCH_FAILURE,
  CONFIG_UNLINKED_VIOLATION_TYPES_FETCH_SUCCESS,
  CONFIG_VIOLATION_TYPES_FETCH_FAILURE,
  CONFIG_VIOLATION_TYPES_FETCH_SUCCESS,
  SYSTEM_ICONS_FETCH_FAILURE,
  SYSTEM_ICONS_FETCH_SUCCESS,
  VIOLATION_TYPE_FETCH_REQUEST,
  VIOLATION_TYPE_FETCH_SUCCESS,
  VIOLATION_TYPES_CREATE_SUCCESS,
  VIOLATION_TYPES_FETCH_FAILURE,
  VIOLATION_TYPES_FETCH_REQUEST,
  VIOLATION_TYPES_FETCH_SUCCESS,
} from '@actions/violationType';

const initialState: IViolationTypeStore = {
  systemIcons: null,
  currentViolationType: null,
  systemViolationTypes: null,
  configViolationTypes: null,
  isFetching: false,
  error: null,
};

export default (state: IViolationTypeStore = initialState, action: any) =>
  produce(state, (draftState: IViolationTypeStore) => {
    switch (action.type) {
      case VIOLATION_TYPE_FETCH_REQUEST:
        draftState.isFetching = true;
        draftState.currentViolationType = null;
        draftState.error = null;

        return;

      case VIOLATION_TYPE_FETCH_SUCCESS:
        draftState.isFetching = false;
        draftState.currentViolationType = action.response;
        draftState.error = null;

        return;

      case VIOLATION_TYPES_FETCH_REQUEST:
        draftState.isFetching = true;
        draftState.error = null;

        return;

      case VIOLATION_TYPES_FETCH_SUCCESS:
        draftState.isFetching = false;
        draftState.systemViolationTypes = action.response;
        draftState.error = null;

        return;

      case VIOLATION_TYPES_FETCH_FAILURE:
        draftState.isFetching = false;
        draftState.error = action.err;

        return;

      case VIOLATION_TYPES_CREATE_SUCCESS:
        draftState.currentViolationType = action.response;

        return;

      case SYSTEM_ICONS_FETCH_SUCCESS:
        draftState.isFetching = true;
        draftState.systemIcons = action.response;
        draftState.error = null;

        return;

      case SYSTEM_ICONS_FETCH_FAILURE:
        draftState.isFetching = false;
        draftState.systemIcons = null;
        draftState.error = action.err;

        return;

      case CONFIG_UNLINKED_VIOLATION_TYPES_FETCH_SUCCESS:
      case CONFIG_VIOLATION_TYPES_FETCH_SUCCESS:
        draftState.isFetching = false;
        draftState.configViolationTypes = action.response;
        draftState.error = null;

        return;

      case CONFIG_UNLINKED_VIOLATION_TYPES_FETCH_FAILURE:
      case CONFIG_VIOLATION_TYPES_FETCH_FAILURE:
        draftState.isFetching = false;
        draftState.configViolationTypes = null;
        draftState.error = action.err;

        return;
    }
  });
